import { routerRefs } from './features/router/routerRefs'

export const refApi = {
	router: routerRefs,
}

export type { RefApi, RefApiValues, ValuesToRefs } from './types'
